import React, { Component } from "react";
import VolunteerList from "./VolunteerList";
import VolunteerAddEdit from "./VolunteerAddEdit";

class Volunteer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
    //this.handleLogoffClick = this.handleLogoffClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <VolunteerList onClick={this.handleClick} />;
    } else {
      return (
        <VolunteerAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data });
    //else this.setState({ data: pData });
    this.setState({ mode });
  }
}

export default Volunteer;
